"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBSingleNegative = function SvgBSingleNegative(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M52.297 57.326h-.59c-12.743 0-23.708-9.623-26.103-22.99a2.109 2.109 0 014.151-.745c2.03 11.351 11.24 19.52 22 19.52h.225a21.516 21.516 0 0015.454-6.322 25.126 25.126 0 007.25-17.82v-.576a25.133 25.133 0 00-7.25-17.856 21.41 21.41 0 00-15.383-6.322h-.246c-10.783 0-20.013 8.162-22.05 19.492a2.107 2.107 0 11-4.144-.744C28.013 9.616 38.978-.001 51.756-.001h.295A25.691 25.691 0 0170.42 7.56a29.343 29.343 0 018.506 20.813v.576a29.343 29.343 0 01-8.506 20.82 25.639 25.639 0 01-18.123 7.558zM2.107 133.625A2.107 2.107 0 010 131.518v-10.073c0-15.3 5.992-30.009 16.43-40.362a49.6 49.6 0 0135.066-14.66h.414l.07 2.107v-2.107a49.564 49.564 0 0134.764 13.88c.056.049 1.623 1.517 3.35 3.343a2.107 2.107 0 01-3.062 2.894c-1.63-1.72-3.16-3.153-3.175-3.168a45.378 45.378 0 00-31.841-12.735h-.106a45.3 45.3 0 00-32.516 13.438c-9.644 9.567-15.18 23.187-15.18 37.37v10.073a2.107 2.107 0 01-2.107 2.107z"
  }), (0, _core.jsx)("path", {
    d: "M83.21 133.73a2.107 2.107 0 01-1.488-.618L66.219 117.61a16.458 16.458 0 0118.6-26.545 2.107 2.107 0 11-1.784 3.814 12.244 12.244 0 00-13.838 19.753L84.7 130.127a2.107 2.107 0 01-1.49 3.603z"
  }), (0, _core.jsx)("path", {
    d: "M89.442 143.67H2.107a2.107 2.107 0 010-4.215h87.335a4.432 4.432 0 003.154-1.313l23.475-23.511c4.623-4.806 4.55-12.427-.165-17.143-4.714-4.717-12.335-4.793-17.143-.172l-4.636 4.629a2.107 2.107 0 11-2.979-2.978l4.63-4.63a16.453 16.453 0 1123.264 23.272L95.581 141.12a8.612 8.612 0 01-6.14 2.55zM67.708 97.934a2.107 2.107 0 01-1.49-3.596 16.395 16.395 0 0120.273-2.375 2.107 2.107 0 01-2.198 3.569 12.201 12.201 0 00-15.082 1.77 2.107 2.107 0 01-1.503.632z"
  })));
};

var _default = SvgBSingleNegative;
exports["default"] = _default;